import { render, staticRenderFns } from "./order.vue?vue&type=template&id=3f70ae9b&scoped=true&"
import script from "./order.vue?vue&type=script&lang=js&"
export * from "./order.vue?vue&type=script&lang=js&"
import style0 from "./order.vue?vue&type=style&index=0&id=3f70ae9b&lang=less&scoped=true&"
import style1 from "./order.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f70ae9b",
  null
  
)

export default component.exports